/*
 * Integreat Electronics - Request List
 * Handles dealer-restricted products that cannot be sold via online checkout.
 * Customers add items to a browser-stored "request list", then submit one
 * request (contact form + mailto fallback) so the team can send a draft invoice.
 */
(function () {
  'use strict';

  if (window.__integreatRequestListLoaded) return;
  window.__integreatRequestListLoaded = true;

  var STORAGE_KEY = 'integreat_request_list_v1';
  var PAGE_URL = (window.INTEGREAT_REQUEST_PAGE_URL && window.INTEGREAT_REQUEST_PAGE_URL !== '')
    ? window.INTEGREAT_REQUEST_PAGE_URL
    : '/pages/request-to-purchase';
  var SALES_EMAIL = window.INTEGREAT_SALES_EMAIL || 'sales@integreatelectronics.com';

  var listeners = [];

  function subscribe(fn) { listeners.push(fn); return fn; }

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function write(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
    notify(items);
  }

  function notify(items) {
    items = items || read();
    listeners.forEach(function (fn) { try { fn(items); } catch (e) {} });
  }

  function count(items) {
    items = items || read();
    return items.reduce(function (n, it) { return n + (parseInt(it.qty, 10) || 1); }, 0);
  }

  function money(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function add(item) {
    if (!item || !item.variantId) return;
    var items = read();
    var key = String(item.variantId);
    var existing = null;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variantId) === key) { existing = items[i]; break; }
    }
    var addQty = parseInt(item.qty, 10) || 1;
    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 1) + addQty;
    } else {
      items.push({
        variantId: key,
        productId: item.productId ? String(item.productId) : '',
        title: item.title || '',
        variantTitle: item.variantTitle || '',
        sku: item.sku || '',
        price: parseInt(item.price, 10) || 0,
        url: item.url || '',
        image: item.image || '',
        vendor: item.vendor || '',
        qty: addQty
      });
    }
    write(items);
  }

  function remove(variantId) {
    var key = String(variantId);
    write(read().filter(function (it) { return String(it.variantId) !== key; }));
  }

  function setQty(variantId, qty) {
    var key = String(variantId);
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 1) { return remove(variantId); }
    var items = read();
    items.forEach(function (it) { if (String(it.variantId) === key) it.qty = qty; });
    write(items);
  }

  function clear() { write([]); }

  var API = {
    add: add, remove: remove, setQty: setQty, clear: clear,
    getAll: read, count: function () { return count(); }, money: money,
    subscribe: subscribe, pageUrl: PAGE_URL, salesEmail: SALES_EMAIL
  };
  window.IntegreatRequestList = API;

  // ---------- Add-to-request buttons (event delegation) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.integreat-request-add') : null;
    if (!btn) return;
    e.preventDefault();
    var block = btn.closest('[data-integreat-request]');
    if (!block) return;
    var dataEl = block.querySelector('.integreat-request-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!data.variants || !data.variants.length) return;

    // Selected variant: read ?variant= from URL (Dawn keeps this in sync), else first.
    var selId = null;
    try { selId = new URL(window.location.href).searchParams.get('variant'); } catch (err2) {}
    var variant = null;
    if (selId) {
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(selId)) { variant = data.variants[i]; break; }
      }
    }
    if (!variant) variant = data.variants[0];

    // Quantity from the section's quantity input if present.
    var qty = 1;
    var section = btn.closest('.shopify-section') || document;
    var qtyInput = section.querySelector('.quantity__input');
    if (qtyInput && qtyInput.value) { qty = parseInt(qtyInput.value, 10) || 1; }

    add({
      variantId: variant.id,
      productId: data.productId,
      title: data.title,
      variantTitle: (variant.title && variant.title !== 'Default Title') ? variant.title : '',
      sku: variant.sku,
      price: variant.price,
      url: data.url,
      image: data.image,
      vendor: data.vendor,
      qty: qty
    });

    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent.trim());
    btn.textContent = 'Added to request ✓';
    btn.disabled = true;
    setTimeout(function () {
      btn.textContent = btn.getAttribute('data-label');
      btn.disabled = false;
    }, 1800);
  });

  // ---------- Floating "Request list" button ----------
  var fab;
  function ensureFab() {
    if (fab) return fab;
    fab = document.createElement('a');
    fab.className = 'integreat-request-fab';
    fab.href = PAGE_URL;
    fab.setAttribute('aria-label', 'View your request list');
    fab.innerHTML =
      '<span class="integreat-request-fab__label">Request list</span>' +
      '<span class="integreat-request-fab__count" data-count>0</span>';
    document.body.appendChild(fab);
    return fab;
  }
  function renderFab(items) {
    items = items || read();
    var c = count(items);
    var el = ensureFab();
    var countEl = el.querySelector('[data-count]');
    if (countEl) countEl.textContent = c;
    if (c > 0) { el.classList.add('is-visible'); } else { el.classList.remove('is-visible'); }
  }

  // ---------- Request-to-purchase page ----------
  function itemsToText(items) {
    var lines = [];
    items.forEach(function (it, idx) {
      var name = it.title + (it.variantTitle ? ' - ' + it.variantTitle : '');
      var parts = [(idx + 1) + '. ' + name];
      if (it.sku) parts.push('SKU: ' + it.sku);
      parts.push('Qty: ' + (it.qty || 1));
      if (it.url) parts.push(window.location.origin + it.url);
      lines.push(parts.join(' | '));
    });
    return lines.join('\n');
  }

  function renderPage() {
    var app = document.getElementById('IntegreatRequestApp');
    if (!app) return;

    var posted = false;
    try { posted = new URL(window.location.href).searchParams.get('contact_posted') === 'true'; } catch (e) {}
    if (posted) { clear(); }

    var itemsWrap = app.querySelector('#IntegreatRequestItems');
    var emptyEl = app.querySelector('.irl-empty');
    var contentEl = app.querySelector('.irl-content');
    var postedEl = app.querySelector('.irl-posted');
    var form = document.getElementById('IntegreatRequestForm');
    var bodyField = document.getElementById('IntegreatRequestBody');
    var mailtoBtn = document.getElementById('IntegreatRequestMailto');
    var notesEl = document.getElementById('IntegreatRequestNotes');

    function syncBody() {
      var items = read();
      var note = (notesEl && notesEl.value) ? '\nNotes: ' + notesEl.value + '\n' : '';
      if (bodyField) {
        bodyField.value = 'Request to purchase (dealer-restricted items):\n\n' +
          itemsToText(items) + '\n' + note;
      }
      if (mailtoBtn) {
        var subject = 'Request to purchase - ' + items.length + ' item(s)';
        var body = 'Hi Integreat Electronics,\n\nI would like to request a quote/invoice for the following:\n\n' +
          itemsToText(items) + note + '\n\nName:\nEmail:\nPhone:\n';
        mailtoBtn.href = 'mailto:' + SALES_EMAIL +
          '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      }
    }

    function draw() {
      var items = read();
      if (postedEl) postedEl.hidden = !posted;
      if (!items.length) {
        if (emptyEl) emptyEl.hidden = posted;
        if (contentEl) contentEl.hidden = true;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      if (contentEl) contentEl.hidden = false;
      if (itemsWrap) {
        var html = '<table class="irl-table"><thead><tr>' +
          '<th>Product</th><th>SKU</th><th class="irl-qty-col">Qty</th><th></th>' +
          '</tr></thead><tbody>';
        items.forEach(function (it) {
          var name = it.title + (it.variantTitle ? ' <span class="irl-variant">(' + it.variantTitle + ')</span>' : '');
          html += '<tr data-vid="' + it.variantId + '">' +
            '<td class="irl-name">' +
              (it.image ? '<img src="' + it.image + '" alt="" class="irl-thumb">' : '') +
              '<span>' + name + '</span></td>' +
            '<td class="irl-sku">' + (it.sku || '—') + '</td>' +
            '<td class="irl-qty-col"><input type="number" min="1" value="' + (it.qty || 1) + '" class="irl-qty" aria-label="Quantity"></td>' +
            '<td><button type="button" class="irl-remove link">Remove</button></td>' +
          '</tr>';
        });
        html += '</tbody></table>';
        itemsWrap.innerHTML = html;
      }
    }

    app.addEventListener('input', function (e) {
      if (e.target.classList.contains('irl-qty')) {
        var row = e.target.closest('tr');
        if (row) setQty(row.getAttribute('data-vid'), e.target.value);
      }
      if (e.target.id === 'IntegreatRequestNotes') syncBody();
    });
    app.addEventListener('click', function (e) {
      if (e.target.classList.contains('irl-remove')) {
        var row = e.target.closest('tr');
        if (row) remove(row.getAttribute('data-vid'));
      }
    });
    if (form) {
      form.addEventListener('submit', function () { syncBody(); });
    }

    subscribe(function () { draw(); syncBody(); });
    draw();
    syncBody();
  }

  // ---------- Init ----------
  function init() {
    renderFab();
    subscribe(renderFab);
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
